import routes from './routes';
import { SetRoutes } from 'components';

const ProductsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default ProductsPages;
